import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import "./button.css";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  loading?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = "primary",
    size = "md",
    fullWidth = false,
    loading = false,
    iconLeft,
    iconRight,
    disabled,
    children,
    className,
    type,
    ...rest
  },
  ref,
) {
  const classes = [
    "wp-btn",
    `wp-btn--${variant}`,
    `wp-btn--${size}`,
    fullWidth ? "wp-btn--full" : null,
    loading ? "wp-btn--loading" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      ref={ref}
      type={type ?? "button"}
      className={classes}
      aria-disabled={disabled || loading ? "true" : undefined}
      aria-busy={loading || undefined}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <span className="wp-btn__spinner" aria-hidden="true" />
      ) : iconLeft ? (
        <span className="wp-btn__icon" aria-hidden="true">
          {iconLeft}
        </span>
      ) : null}
      <span className="wp-btn__label">{children}</span>
      {iconRight && !loading ? (
        <span className="wp-btn__icon" aria-hidden="true">
          {iconRight}
        </span>
      ) : null}
      {loading ? <span className="visually-hidden">Завантаження…</span> : null}
    </button>
  );
});
